"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "mb-6 mt-10 flex justify-center py-3" };
var _hoisted_2 = { class: "my-4 mb-2 text-xl font-semibold" };
var _hoisted_3 = {
    key: 0,
    class: "mb-4 text-sm leading-5"
};
var _hoisted_4 = { class: "mb-10 text-sm leading-5" };
var _hoisted_5 = { class: "mb-20" };
var vue_3 = require("vue");
var vue_i18n_1 = require("vue-i18n");
var vue_router_1 = require("vue-router");
var ocm_object_1 = require("@ocm/services/ocm-object");
var SvgIcon_vue_1 = require("@SharedVueComponents/SvgIcon/SvgIcon.vue");
var SharedButton_vue_1 = require("@SharedVueComponents/SharedButton.vue");
var routeName_type_1 = require("@/types/routeName.type");
var use_messageData_1 = require("@/composables/use-messageData");
var use_formValidity_1 = require("@/composables/use-formValidity");
var use_pageNavigation_1 = require("@/composables/use-pageNavigation");
var use_polly_1 = require("@/composables/use-polly");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ThankYouPage',
    setup: function (__props) {
        var route = (0, vue_router_1.useRoute)();
        var t = (0, vue_i18n_1.useI18n)({}).t;
        var isWithdrawalConfirmation = (0, vue_3.computed)(function () { return route.query.flow === "withdrawal"; });
        var withdrawalOrderNumber = (0, vue_3.computed)(function () { return route.query.orderNumber || ""; });
        var headline = (0, vue_3.computed)(function () {
            return isWithdrawalConfirmation.value ? t("thankYouPage.withdrawalHeadline") : t("thankYouPage.headline");
        });
        var text = (0, vue_3.computed)(function () {
            return isWithdrawalConfirmation.value ? t("thankYouPage.withdrawalText") : t("thankYouPage.text");
        });
        (0, vue_3.onMounted)(function () {
            var _a;
            var areNotAllStepsCompleted = !use_formValidity_1.areAllStepsCompleted.value; // get state before resetting the form
            resetContactForm();
            if (!isWithdrawalConfirmation.value && areNotAllStepsCompleted)
                (0, use_pageNavigation_1.startContactForm)((_a = use_polly_1.currentCollection.value) === null || _a === void 0 ? void 0 : _a.id, true);
        });
        function resetContactForm() {
            use_formValidity_1.completedSteps.value.clear();
            (0, use_messageData_1.resetInputData)();
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                        "icon-name": "send-email",
                        class: "h-[60px] w-[60px]"
                    })
                ]),
                (0, vue_2.createElementVNode)("h2", _hoisted_2, (0, vue_2.toDisplayString)(headline.value), 1),
                (isWithdrawalConfirmation.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                        (withdrawalOrderNumber.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_3, (0, vue_2.toDisplayString)(_ctx.$t("thankYouPage.withdrawalOrderNumber", { orderNumber: withdrawalOrderNumber.value })), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("p", _hoisted_4, (0, vue_2.toDisplayString)(text.value), 1),
                        (0, vue_2.createVNode)(SharedButton_vue_1.default, {
                            href: "".concat((0, vue_2.unref)(ocm_object_1.contextPath), "/"),
                            variant: "primary",
                            class: "w-3/4 lg-down:w-full"
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$t("thankYouPage.withdrawalCta")), 1)
                            ]; }),
                            _: 1
                        }, 8, ["href"])
                    ], 64))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                        (0, vue_2.createElementVNode)("p", _hoisted_5, (0, vue_2.toDisplayString)(text.value), 1),
                        (0, vue_2.createVNode)(SharedButton_vue_1.default, {
                            href: "".concat((0, vue_2.unref)(ocm_object_1.contextPath), "/"),
                            variant: "primary",
                            class: "mb-4 w-3/4 lg-down:w-full"
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$t("thankYouPage.cta")), 1)
                            ]; }),
                            _: 1
                        }, 8, ["href"]),
                        (0, vue_2.createVNode)(SharedButton_vue_1.default, {
                            to: { name: (0, vue_2.unref)(routeName_type_1.SELECTION_PAGE_NAME) },
                            variant: "secondary",
                            class: "w-3/4 lg-down:w-full"
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$t("thankYouPage.ctaSecondary")), 1)
                            ]; }),
                            _: 1
                        }, 8, ["to"])
                    ], 64))
            ]));
        };
    }
});
